import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconHierarchyView = ({ width = '24px', height = '24px', viewBox = '0 0 24 24', color = colors.mineShaft }) =>
    <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M20 13V7H9V9H4V5H6V0H0V5H2V18H9V20H20V14H9V16H4V11H9V13H20Z' fill={color} />
    </svg>;

IconHierarchyView.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    color: PropTypes.string
};

export default IconHierarchyView;
